import axios from "axios";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

/*** Queries **********************/

const _fetcher = (baseUrl, agreementCode = null) => {
    const uri = (agreementCode) ? `/${agreementCode}` : '';
    return axios.get(`${baseUrl}${uri}`)
        .then(res => {
            return res.data
        });
}


export const useAgreementQuery = (agreementCode = null, includes = [], fetcher = _fetcher) => {
    return useQuery(['agreements', agreementCode], () => fetcher('/api/protected/agreements', agreementCode, includes), {refetchInterval: 10000})
}

/*** Mutations **********************/


export const createAgreementMutation = (param) => {
    return axios.post(`/api/protected/agreements`, param)
        .then(res => res)
}

export const useCreateAgreementMutation = (mutator = createAgreementMutation) => {
    const queryClient = useQueryClient()
    return useMutation(
        ['create-agreement'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(["agreements"])}
    );
}

export const updateAgreementStatusMutation = async (params) => {
    const [affiliationCode, data] = params
    return await axios.put(`/api/protected/agreements/${affiliationCode}/status`, data)
        .then(res => res);
}
export const useUpdateAgreementStatusMutation = (mutator = updateAgreementStatusMutation) => {
    const queryClient = useQueryClient()
    return useMutation(
        ['update-agreements'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(["agreements"])}
    );
}

/*** Queries UnProtected **********************/


export const checkAgreementMutation = (param) => {
    return axios.get(`/api/agreements/${param}`, {validateStatus: (status) => [200, 404].includes(status)})
        .then(res => res)
}
export const checkStatusAgreementMutation = (param) => {
    return axios.get(`/api/agreements/${param}/status`)
        .then(res => res)
}
export const useCheckAgreementMutation = (mutator = checkAgreementMutation) => {
    return useMutation(
        ['check-agreements'],
        (params) => mutator(params)
    );
}
export const useCheckStatusAgreementMutation = (mutator = checkStatusAgreementMutation) => {
    return useMutation(
        ['check-status-agreements'],
        (params) => mutator(params)
    );
}